<p-dialog
  header="{{ 'DATA_PORTAL.ADMINISTRATION.CENSUS.CENSUS_DIALOG.HEADER' | translate }}"
  [(visible)]="display"
  [modal]="true"
  [draggable]="false"
  class="admin-dialog">
  <form [formGroup]="censusForm" (submit)="save()">
    <div class="ui-g service-edit-dialog">
      <div class="ui-g-12">
        <div class="ui-g m-b-0">
          <div class="ui-g-5">
            <label>{{ 'DATA_PORTAL.ADMINISTRATION.CENSUS.CENSUS_DIALOG.YEAR_LABEL' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <wsd-extended-input [control]="censusForm.get('year')">
              <p-dropdown [options]="years"
                          placeholder="{{'DATA_PORTAL.ADMINISTRATION.CENSUS.CENSUS_DIALOG.YEAR_PLACEHOLDER' | translate}}"
                          formControlName="year">
              </p-dropdown>
            </wsd-extended-input>
          </div>
          <div class="ui-g-12">
            <div class="ui-g m-b-0">
              <div class="ui-g-5">
                <label>{{ 'DATA_PORTAL.ADMINISTRATION.CENSUS.CENSUS_DIALOG.STARTING_DATE' | translate }}</label>
              </div>
              <div class="ui-g-7">
                <wsd-extended-input [control]="censusForm.get('startDate')">
                  <p-calendar wsdUseUtc [showIcon]="true"
                              dateFormat="dd/mm/yy"
                              [readonlyInput]="true"
                              appendTo="body"
                              [maxDate]="censusForm.get('endDate').value"
                              formControlName="startDate">
                  </p-calendar>
                </wsd-extended-input>
              </div>
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g m-b-0">
              <div class="ui-g-5">
                <label>{{ 'DATA_PORTAL.ADMINISTRATION.CENSUS.CENSUS_DIALOG.CLOSING_DATE' | translate }}</label>
              </div>
              <div class="ui-g-7">
                <wsd-extended-input [control]="censusForm.get('endDate')">
                  <p-calendar wsdUseUtc [showIcon]="true"
                              dateFormat="dd/mm/yy"
                              [readonlyInput]="true"
                              appendTo="body"
                              [minDate]="censusForm.get('startDate').value"
                              formControlName="endDate">
                  </p-calendar>
                </wsd-extended-input>
              </div>
            </div>
          </div>
          <div class="ui-g-5"></div>
          <div class="ui-g-offset-5 ui-g-7"
               *ngIf="censusForm.errors?.dateOverlapping && (censusForm.touched || censusForm.dirty)">
            <span class="error">{{ 'DATA_PORTAL.ADMINISTRATION.CENSUS.CENSUS_DIALOG.DATE_OVERLAPPING' | translate }}</span>
          </div>
          <div class="ui-g-offset-5 ui-g-7">
            <button
              pButton
              class="ui-button-success inline-block m-r-15"
              type="submit"
              [label]="'DATA_PORTAL.ADMINISTRATION.CENSUS.CENSUS_DIALOG.SAVE_BUTTON' | translate">
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
